import { Factory } from 'fishery'
import faker from 'faker'

export default Factory.define<APIResponse.DME.OrderItem>(() => ({
  price: faker.commerce.price(),
  name: faker.commerce.productName(),
  quantity: faker.datatype.number(),
  imageUrl: faker.internet.url(),
}))
